
import DashboardScoringTable from "../components/DashboardScoringTable";
import PendingTaskCards from "../components/PendingTaskCards";
import WhatsNewSection from "../components/WhatsNewSection";
import TopDepartmentAchivementPage from "../components/TopDepartmentAchivementPage";
import CommitmentSummaryCard from "../components/CommitmentSummaryCard";
import CumulativeCard from "../components/CumulativeCard";


// export default function DashboardHome({ activeDoerEmail }) {
export default function DashboardHome({ activeDoerEmail, onNavigate }){
  return (
    <div className="homeWrapper">

      {/* 🔵 New Section */}
      <div className="liveScoringSection">

        <div className="liveSectionTitle">
            Live Scoring and Pending Tasks
          <hr style={{marginBottom:2}} />
          </div>

<div className="topCardsRow">
<PendingTaskCards />

  <CommitmentSummaryCard />

<CumulativeCard/>

</div>

<div className="fullTable">
  <DashboardScoringTable />
</div>

      </div>

      <TopDepartmentAchivementPage activeDoerEmail={activeDoerEmail} />
      <WhatsNewSection activeDoerEmail={activeDoerEmail} />

    </div>
  );
}